var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticStyle:{"display":"inline"}},[(_vm.isNamesLoading)?_c('div',{staticClass:"loader-wrapper"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"secondary","size":"15"}})],1):_vm._e(),(!_vm.isNamesLoading)?_c('span',[_vm._v(" "+_vm._s(_vm.nodeNames))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }